import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import enOrderStepType from '../../../../../api/enums/enOrderStepType';
import { formatDate } from 'fulogics-ui-core/dist/utils/dates';

const OrderForwardPlannedStartDateColumnTemplate = (props: CellTemplateProps) => {
    const isUnload = props?.data?.type === enOrderStepType.Unload;
    const plannedStartDate = props?.data?.plannedStartDate;

    return (
        <>
            {isUnload ? (
                <div>
                    {plannedStartDate ? formatDate(plannedStartDate, 'DD.MM.yyyy, HH:mm') : ''}
                </div>
            ) : (
                <div />
            )}
        </>
    );
};

export const OrderForwardPlannedStartDateColumnTemplateDefaultProps = {};

export const OrderForwardPlannedStartDateColumnTemplatePredProps = (
    current: ColumnProps
): ColumnProps => {
    return {
        ...current,
    };
};

export type OrderForwardPlannedStartDateColumnTemplateData = { plannedStartDate?: Date };

export const OrderForwardPlannedStartDateColumnTemplateDataKeys = ['plannedStartDate'];

export default OrderForwardPlannedStartDateColumnTemplate;
